import ApiService from '../../api/api';
import Vuex from 'vuex';
import Vue from 'vue';
import {router} from '../../router';

Vue.use(Vuex);

export default {
    namespaced: true,
    state() {
        return {
            step: 1,
            form: {
                photos: [],
                custom_birthday_at: null,
                custom_died_at: null,
            },
            show: false,
            individualPages: [],
            familyPages: [],
            passwordInfo: {
                id: null,
                password: null,
            },
            refreshAccess: false,
            croppedStatus: {
                cropper_main_image: true,
                biography_photo1: true,
                biography_photo2: true,
                biography2_photo: true,
                biography3_photo1: true,
                biography3_photo2: true,
            }
        }
    },
    getters: {
        form: state => {
            return state.form;
        },
        croppedStatus: (state) => {
            return state.croppedStatus;
        },
    },
    mutations: {
        setCroppedStatus(state, [key, value]) {
            state.croppedStatus[key] = value;
        },
        setStep(state, value) {
            state.step = value;
        },
        setShow(state, show) {
            state.show = show;
        },
        setPageType(state, type) {
            state.form.page_type_id = type;
        },
        setForm(state, form) {
            state.form = form;
        },
        setBiografy(state, biografy) {
            state.biografy = biografy;
        },
        setFormComment(state, form) {
            state.form.itemComments = form;
        },
        setRefreshAccess(state, value) {
            state.refreshAccess = value;
        },
        addPageInformation(state, value) {
            state.form.page_information.push(value);
        },
        setPageInformation(state, value) {
            state.form.page_information = value;
        },
        setFormPhotos(state, value) {
            state.form.photos = value;
        },
        setStartAt(state, dateAt) {
            if (dateAt === null) {
                dateAt = {
                    day: null,
                    month: null,
                    year: null,
                };
            }

            state.form.start = dateAt;
        },
        setEndAt(state, dateAt) {
            if (dateAt === null) {
                dateAt = {
                    day: null,
                    month: null,
                    year: null,
                };
            }

            state.form.end = dateAt;
        },
        setBirthdayAt(state, birthday_at) {
            state.form.birthday_at = birthday_at;
        },
        setDiedAt(state, died_at) {
            state.form.died_at = died_at;
        },
        setCustomBirthdayAt(state, customAt) {
            state.form.custom_birthday_at = customAt;
        },
        setCustomDiedAt(state, customAt) {
            state.form.custom_died_at = customAt;
        },
    },
    actions: {
        getPage({state, commit, getters} ,slug){
            return new Promise((resolve, reject) => {
                ApiService.get('/page/'+ slug)
                    .then((response) => {
                        commit('setForm', response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        createPage({state, commit, getters} ){
            Vue.prototype.$loading(Vue.prototype.$optionsLoading);

            return new Promise((resolve, reject) => {
                ApiService.post('/page', state.form)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    })
                    .finally(() => {
                        Vue.prototype.$loading({}).close();
                    });
            });
        },
        updatePage({state, commit, getters}, slug){
            Vue.prototype.$loading(Vue.prototype.$optionsLoading);

            return new Promise((resolve, reject) => {
                ApiService.update('/page/'+ slug , state.form)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    })
                    .finally(() => {
                        Vue.prototype.$loading({}).close();
                    });
            });
        },
        getCemeteries({state, commit, getters}){
            return new Promise((resolve, reject) => {
                ApiService.get('/cemeteries/all')
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            });
        },
        searchPage({state, commit, getters}, search){
            return new Promise((resolve, reject) => {
                ApiService.post('/page/search', search)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            });
        },
        sendRelation({state, commit, getters}, search) {
            return new Promise((resolve, reject) => {
                ApiService.post('/page/relative', search)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        createComment({state, commit, getters}, form){
            return new Promise((resolve, reject) => {
                ApiService.post('/comment', form)
                    .then((response) => {
                        commit('setFormComment', response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        updateComment({state, commit, getters}, form){
            return new Promise((resolve, reject) => {
                ApiService.update('/comment/'+ form.id, form)
                    .then((response) => {
                        commit('setFormComment', response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        publicComment({state, commit, getters}, form){
            return new Promise((resolve, reject) => {
                ApiService.post('/comment/public', form)
                    .then((response) => {
                        commit('setFormComment', response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        deleteComment({state, commit, getters}, id){
            return new Promise((resolve, reject) => {
                ApiService.delete('/comment/'+ id)
                    .then((response) => {
                        commit('setFormComment', response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getMyQrcode({state, commit, getters}, params) {
            return new Promise((resolve, reject) => {
                ApiService.download('/qrcode-download', params)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getMyQrcodeTree({state, commit, getters}, params) {
            return new Promise((resolve, reject) => {
                ApiService.download('/qrcode-tree-download', params)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        preview({state, commit, getters}) {
            return new Promise((resolve, reject) => {
                ApiService.post('/page/preview', state.form)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getPages({state, commit, getters}) {
            ApiService.get('/cabinet/individual-pages')
                .then((response) => {
                    state.individualPages = response.data;
                }).catch((error) => {
            });

            ApiService.get('/cabinet/family-pages')
                .then((response) => {
                    state.familyPages = response.data;
                }).catch((error) => {
            });
        },
        getUserPages({state, commit, getters}) {
            return new Promise((resolve, reject) => {
                ApiService.get('/cabinet/user-pages')
                    .then((response) => {
                        resolve(response);
                    }).catch((error) => {
                    reject(error);
                });
            });
        },
        setPassword({state, dispatch}) {
            ApiService.post('/page/toggle-access', {
                    page_id: state.passwordInfo.id,
                    access_password: state.passwordInfo.password,
                })
                .then((response) => {
                    if (state.passwordInfo.password) {
                        router.push(window.laravel.url);
                        state.form.access_password = response.data.access_password;
                        state.passwordInfo.password = null;
                    }
                    state.refreshAccess = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        changeAccess({state, dispatch}, page) {
            if (!page.accessible_by_password) {
                router.push({name: 'cabinet-page-password', params: {page_id: page.id}});
            } else {
                state.passwordInfo.id = page.id;

                dispatch('setPassword');
            }
        },
        changePublish({state, dispatch}, page) {
            ApiService.post('/page/toggle-publish', {page_id: page.id})
                .then((response) => {
                    console.log('publish parameter was changed');
                }).catch((error) => {
                console.log(error);
            });
        },
        sendQrcodeStone({state, dispatch}, form) {
            return new Promise((resolve, reject) => {
                ApiService.post('/cabinet/qrcode-stone', form)
                    .then((response) => {
                        resolve(response);
                    }).catch((error) => {
                    reject(error);
                });
            });
        },
        getKinships({state, commit, getters}) {
            return new Promise((resolve, reject) => {
                ApiService.get('/cabinet/kinships/all')
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
    }
};


